export default "__VITE_ASSET__BtmORsmg__"